import { Injectable } from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router} from "@angular/router";
import { AuthenticationService } from "../share-modul/services/authentication/authentication.service";
import { RoleNameEnum } from "../admin-panel/enums/role-name.enum";
import { UserModel } from "../share-modul/models/user/user.model";

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  //#region Fields
  private user: UserModel | null = null;
  //#endregion

  //#region Constructor
  constructor(private authService: AuthenticationService, private _router: Router) {
    this.authService.loginUser.subscribe(it => {
      this.user = it;
    });
  }
  //#endregion

  //#Private Methods
  canActivate(): boolean {
    const loggedIn = this.user !== null;
    if (loggedIn) {
      this._router.navigate(['dashboard']);
    }
    return !loggedIn;
  }
  //#endregion
}
